import { UserProfile } from "../UserToken";
import { CreateTenant } from "./Tenant";

export interface ApartmentComplex {
    id: string;
    name: string;
    typeOfComplex: number;
    squareMeters: number;
    description: string;
    facebook: string | null;
    instagram: string | null;
    hasElevator: boolean;
    hasSecurity: boolean;
    hasPool: boolean;
    hasGym: boolean;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    userProfile: UserProfile;
    location: string;
    parkingSpaces: ComplexParkingSpace[];
    multimedia: string[];
}

export interface CreateApartmentComplex {
    name: string;
    typeOfComplex: typeOfComplexOptions;
    ownerId: number;
    squareMeters?: number;
    totalFloors?: number;
    totalParkingSpaces?: number;
    description?: string;
    facebook?: string | null;
    instagram?: string | null;
    hasSecurity?: boolean;
    hasPool?: boolean;
    hasGym?: boolean;
    location: string;
    files?: File[];
}

export interface CreateApartmentForComplex {
    apartmentNumber: string;
    apartmentComplexId?: string;
    assignedFloorId: string;
    assignedParkingSpaceId?: string;
    apartmentType: ApartmentType | undefined;
    apartmentStatus: ApartmentStatus;
    bathrooms: number;
    squareMeters: number;
    hasBalcony: boolean;
    baseRentAmount: number;
    currency: CurrencyType;
    securityDeposit: number;
    description: string;
    tenant: CreateTenant;
    apartmentHistory: CreateApartmentHistoryDto;
    hasOwnParking: boolean;
    files?: File[];
    apartmentServices: CreateApartmentService[];
}

export interface CreateSingleApartment {
    apartmentTitle: string;
    apartmentType: ApartmentType;
    apartmentStatus: ApartmentStatus;
    bathrooms: number;
    squareMeters: number;
    hasBalcony: boolean;
    baseRentAmount: number;
    currency: CurrencyType;
    securityDeposit: number;
    description: string;
    tenant: CreateTenant;
    apartmentHistory: CreateApartmentHistoryDto;
    hasOwnParking: boolean;
}

export interface CreateApartmentHistoryDto {
    apartmentId?: string;
    tenantId?: string;
    moveInDate: string;
    isCurrentTenant?: boolean;
    notes?: string;
}

export interface CreateApartmentService
{
    ApartmentId?: string;
    Provider?: string;
    ServiceAccount?: string;
    IsIncludedInRent?: boolean;
    ServiceTypeId: number | undefined;
}

export interface UploadComplexFile{
    files: File[];
    apartmentComplexId: string;
}

export interface UploadApartmentFile{
    files: File[];
    apartmentId: string;
}

export interface CreateSpaceParking{
    spaceNumber: string;
    isHandicapped: boolean;
    isAvailable: boolean;
    apartmentComplexId: string;
}

export interface ComplexParkingSpace{
    id: string;
    spaceNumber: number;
    complexId: string;
}

export interface ComplexFloor{
    id: string;
    floorNumber: number;
    complexId: string;
}

export enum typeOfComplexOptions {
    Residencial = 1,
    Edificio = 2,
    Condominio = 3,
    Otro = 4
}

export enum ApartmentSideType {
    OESTE = 1,
    ESTE = 2,
    NORTE = 3,
    SUR = 4
}

export enum ApartmentType {
    ESTUDIO = 1,
    UN_DORMITORIO = 2,
    DOS_DORMITORIOS = 3,
    TRES_DORMITORIOS = 4,
    CUATRO_DORMITORIOS = 5,
}

export enum ApartmentStatus {
    DISPONIBLE = 1,
    OCUPADO = 2,
    NO_DISPONIBLE = 3,
}

export enum CurrencyType {
    USD = 1,
    CRC = 2,
}



